import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PainHistoryQueryModel} from '../../modules/pain-history/models/pain-history-query-model';
import {PainHistoryPatientFormsModel} from '../../modules/pain-history/models/pain-history-patient-forms.model';
import {FormItemDataModel} from '../../models/forms/data/form-item-data.model';
import {PainEndoDataModel} from '../../modules/pain-history/models/pain-endo-data.model';
import {PainEndoDetailDataModel} from '../../modules/pain-history/models/pain-endo-detail-data.model';

@Injectable({
  providedIn: 'root'
})
export class PainHistoryService {

  constructor(private http: HttpClient) {

  }

  getPatientPainHistoryForms(patientId: string) {
    return this.http.get<PainHistoryPatientFormsModel[]>(`api/pain-history/get-patient-pain-history-forms/${patientId}`);
  }

  getDoctorFilledPainHistory(CaseWorkItemFormsId: string) {
    return this.http.get<PainEndoDataModel>(`api/pain-history/get-doctor-filled-pain-history/${CaseWorkItemFormsId}`);
  }

  getPainHistory(model: PainHistoryQueryModel): Observable<PainEndoDataModel[]> {
    return this.http.post<PainEndoDataModel[]>('api/pain-history/get-pain-history', model);
  }

  getPainHistoryDetails(painID: string): Observable<PainEndoDetailDataModel[]> {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'text/plain'})
    };
    return this.http.get<PainEndoDetailDataModel[]>(`api/pain-history/get-pain-details/${painID}`, httpOptions);
  }

  savePainHistory(model: PainEndoDataModel): Observable<PainEndoDataModel> {
    return this.http.post<PainEndoDataModel>('api/pain-history/save-pain-history', model);
  }

  savePainHistoryDetails(model: PainEndoDetailDataModel[]): Observable<PainEndoDetailDataModel[]> {
    return this.http.post<PainEndoDetailDataModel[]>('api/pain-history/save-pain-details', model);
  }

  deletePainHistory(model: PainEndoDataModel): Observable<PainEndoDataModel> {
    return this.http.post<PainEndoDataModel>('api/pain-history/delete-pain-history', model);
  }

  getFormItemsAndResults(CaseWorkItemFormsId: string) {
    return this.http.get<FormItemDataModel[]>(`api/pain-history/get-pain-form-items-and-results/${CaseWorkItemFormsId}`);
  }

  savePainHistoryDetail(model: PainEndoDetailDataModel) {
    return this.http.post<PainEndoDetailDataModel>('api/pain-history/save-pain-history-detail', model);
  }
}
